// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__o9-Jy","rightAdornment":"Header_rightAdornment__34yE9"};